import { HasOwnProperty } from "#packages/ecma262-abstract/HasOwnProperty.js";
/**
* https://tc39.es/ecma402/#sec-currencydigits
*/
export function CurrencyDigits(c, { currencyDigitsData }) {
	return HasOwnProperty(currencyDigitsData, c) ? currencyDigitsData[c] : 2;
}
